import { filter, map, mergeMap, take } from 'rxjs/operators';
import { timer, from } from 'rxjs';

import { insertIntoLoopQueue } from '../interfaces/sequencer/actions';
import { randomNumberInRange } from './interval/util';

export const resolveLoopQueueItems = ({
   state$,
   queueItemsToResolve,
   nextLevel,
}) =>
   from(queueItemsToResolve).pipe(
      mergeMap((item) => {
         const countKey = `${item.loopKitId}/${item.categoryId}`;
         return timer(0, 100).pipe(
            filter(() => {
               const count =
                  state$.value.activeInterface.loops.categoryCounts[countKey];
               return count && !count.loading;
            }),
            take(1),
            map(() =>
               insertIntoLoopQueue(
                  [
                     {
                        ...item,
                        loopId: randomNumberInRange(
                           1,
                           state$.value.activeInterface.loops.categoryCounts[
                              countKey
                           ]
                        ),
                     },
                  ],
                  nextLevel
               )
            )
         );
      })
   );
